import { Component, HostListener } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    // @HostListener('window:scroll', ['$event']) // for window scroll events
    // onScroll(event) {
    //     let sfCustomModal:any = document.getElementById("sh-app-header");
        
    //     if (event.target.scrollTop > 0) {
    //         sfCustomModal.style.boxShadow = "0px 1px 0px rgba(17,17,26,0.05), 0px 0px 8px rgba(17,17,26,0.1) !important";
    //     } else {
    //         sfCustomModal.style.boxShadow = "";
    //     }
    //     console.log(sfCustomModal);
    // }

    topFunction() {
        // document.body.scrollTop = 0; // For Safari
        // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
}
